<template>
    <div class="app-left-content-header">
        <h1 class="content-title">Panel de Administración</h1>
    </div>

    <div class="app-content-field">
        <div class="card-resume">
            <div class="card-left">
                <div class="card-content">
                    <div class="head-title">
                        Total de Usuarios
                    </div>
                    <div class="content-text">
                        140
                    </div>
                </div>
                <div class="card-footer">
                    <i class="bi bi-person-lines-fill card-icon"></i>
                </div>
            </div>
            <div class="card-right">
                <div class="card-content">
                    <div class="head-title">
                        Total de Aplicaciones
                    </div>
                    <div class="content-text">
                        20
                    </div>
                </div>
                <div class="card-footer">
                    <i class="bi bi-window-plus card-icon"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.card-resume {
    width: 100%;
    height: 30%;
    display: flex;
    justify-content: space-between;
    margin-top: 32px;
    margin-bottom: 32px;
}

.card-left {
    width: 45%;
    padding: 20px;
    margin: 10px;
    background-color: #333333;
}

.card-right {
    width: 45%;
    padding: 20px;
    margin: 10px;
    background-color: #333333;
}

.card-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.card-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    background-color: #FFB22C;
    color: #ffffff;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.head-title {
    color: #FFB22C;
    font-size: 20px;
    font-weight: 500;
}

.content-text {
    color: #ffffff;
    font-size: 24px;
    font-weight: 500;
}
</style>